module.exports = __webpack_public_path__ + "img/wheel_back_2.a159522d.png";